import type { SettingsParamsType } from '@econtractor/types';

/**
 * Migrate legacy reportObjectsServicesMode → reportObjectsShowServices.
 * hide → false; income/expense/unset → true.
 */
const normalizeShowServices = (raw?: Partial<SettingsParamsType> | null): boolean => {
    const anyRaw = raw as Record<string, unknown> | null | undefined;
    if (anyRaw?.reportObjectsShowServices != null) {
        return Boolean(anyRaw.reportObjectsShowServices);
    }
    const legacy = anyRaw?.reportObjectsServicesMode;
    if (legacy == null) return true;
    return legacy !== 'hide';
};

/**
 * Missing / unset params are treated as off (false / 0).
 * Report columns: unset keeps previous behavior (materials on, services on).
 */
export const normalizeSettingsParams = (
    raw?: Partial<SettingsParamsType> | null,
): SettingsParamsType => {
    const vat = Number(raw?.vatPercent);

    return {
        usdDefault: Boolean(raw?.usdDefault),
        vatDefault: Boolean(raw?.vatDefault),
        vatPercent: Number.isFinite(vat) && vat >= 0 ? vat : 0,
        ignoreWarehousePrice: Boolean(raw?.ignoreWarehousePrice),
        objectReservationWarehouses: Boolean(raw?.objectReservationWarehouses),
        creditControl: Boolean(raw?.creditControl),
        objectPaymentControl: Boolean(raw?.objectPaymentControl),
        autoSyncPayStatus: Boolean(raw?.autoSyncPayStatus),
        manualPayStatus: Boolean(raw?.manualPayStatus),
        lockFinishedObject: Boolean(raw?.lockFinishedObject),
        reportObjectsShowMaterials:
            raw?.reportObjectsShowMaterials == null
                ? true
                : Boolean(raw.reportObjectsShowMaterials),
        reportObjectsShowServices: normalizeShowServices(raw),
        tasksModule: Boolean(raw?.tasksModule),
        tasksAutoAcceptOwn: Boolean(raw?.tasksAutoAcceptOwn),
        tasksForLeads: Boolean(raw?.tasksForLeads),
        tasksForObjects: Boolean(raw?.tasksForObjects),
    };
};
